import MDEditor, { MDEditorProps } from '@uiw/react-md-editor';

import { useMarkdownEditorCommands } from './hooks';

export interface MarkdownEditorProps extends Pick<MDEditorProps, 'value' | 'onChange'> {
  disableEdit?: boolean;
}

export const MarkdownEditor = ({ value, onChange, disableEdit }: MarkdownEditorProps) => {
  const editorProps = useMarkdownEditorCommands({ disableEdit });
  return (
    <MDEditor
      value={value}
      onChange={onChange}
      visibleDragbar={false}
      data-color-mode="light"
      fullscreen={false}
      preview={disableEdit ? 'preview' : 'edit'}
      height={500}
      {...editorProps}
    />
  );
};
